module.exports = __webpack_public_path__ + "static/img/economy-banner1.16edfd1f.jpg";